


































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import { AudienceSearchEditConfirm } from '../models/AudienceSearchEditConfirm';
import router from '../router';
import * as $ from 'jquery';
import { IframeParentCommnuicationService } from '@/services/IframeParentCommnuicationService';

@Component({})
export default class AudienceSearchEditConfirmModal extends Vue {

    private LastSavedUpdateDate: string = '';
    private LastSavedUser: string = '';
    private LastPublishedUpdateDate: string = '';
    private LastPublishedUser: string = '';
    private AudienceId: number = 0;
    private DetailId: number = 0;

    private iframeParentCommnuicationService = new IframeParentCommnuicationService();

    public showEditConfirmModal(info: AudienceSearchEditConfirm): void {
        this.LastSavedUpdateDate = info.LastSavedUpdateDate;
        this.LastSavedUser = info.LastSavedUser;
        this.LastPublishedUpdateDate = info.LastPublishedUpdateDate;
        this.LastPublishedUser = info.LastPublishedUser;
        this.AudienceId = info.AudienceId;
        this.DetailId = info.DetailId;
        $('#audienceEditConfirmModal').modal();

        const data = { action: 'eIn_modal_dialog', value: '' };
        this.iframeParentCommnuicationService.SendMessageToParent(data);

        // $([document.documentElement, document.body]).animate({
        //     scrollTop: $('#audienceEditConfirmModal').offset().top
        // }, 1000);
    }

    private reset(): void {
        this.LastSavedUpdateDate = '';
        this.LastSavedUser = '';
        this.LastPublishedUpdateDate = '';
        this.LastPublishedUser = '';
        this.AudienceId = 0;
        this.DetailId = 0;
    }
    private goToEdit() {
        $('#audienceEditConfirmModal').modal('hide');
        const returnURL = encodeURI(this.$router.currentRoute.fullPath);
        this.$router.push(`/audience/${this.AudienceId}/edit/${this.DetailId}?returnURL=${returnURL}`);
    }
}
